import { clsx } from 'clsx';
import { useTocContext } from '../../hooks/useTocContext';
import { TocListItem } from './TocListItem';
import { TOCListItem } from '../../interfaces/toc';
import styles from './TocList.module.scss';

export function TocList() {
  const { items, activeItem, jumpToSection } = useTocContext();

  const onClickListItem = (item: TOCListItem) => {
    jumpToSection(item);
  };

  return (
    <div
      className={clsx(
        'flex-col py-9 border-right pl-7 pr-4 bg-surface overflow-auto h-100',
        styles.tocList
      )}
    >
      <span className='text-caption-2 text-uppercase text-disabled border-bottom pb-1 mb-5'>
        Jump to
      </span>

      {items.map(item => (
        <TocListItem
          key={item.domId}
          item={item}
          isActiveItem={item.domId === activeItem?.domId}
          onClickItem={() => onClickListItem(item)}
        />
      ))}
    </div>
  );
}
